import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

const TARGET = new Date("2026-11-08T00:00:00");

const pad = (n) => String(n).padStart(2, "0");

export const DiwaliBanner = () => {
  const [left, setLeft] = useState(TARGET - new Date());

  useEffect(() => {
    const t = setInterval(() => setLeft(TARGET - new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  if (left <= 0) return null;

  const days = Math.floor(left / 86400000);
  const hours = Math.floor((left % 86400000) / 3600000);
  const mins = Math.floor((left % 3600000) / 60000);
  const secs = Math.floor((left % 60000) / 1000);

  const units = [[days, "days"], [hours, "hrs"], [mins, "min"], [secs, "sec"]];

  return (
    <section className="max-w-[1400px] mx-auto px-4 sm:px-8 lg:px-12 pt-6" data-testid="diwali-banner">
      <div className="relative overflow-hidden rounded-xl gold-border bg-obsidian-2 grain">
        <div
          className="absolute inset-0 opacity-25 bg-cover bg-center"
          style={{ backgroundImage: "url('https://images.unsplash.com/photo-1727430228383-aa1fb59db8bf?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200')" }}
        />
        <div className="relative flex flex-col md:flex-row items-center justify-between gap-5 p-5 sm:p-6">
          <div className="flex items-center gap-3 text-center md:text-left">
            <Sparkles className="w-6 h-6 text-gold shrink-0 animate-float" />
            <div>
              <p className="caption">Limited-time festive event</p>
              <h3 className="font-serif text-2xl sm:text-3xl text-gold-light leading-tight mt-1">
                The Diwali Edit is live — up to <span className="gold-text">the finest zari</span> awaits
              </h3>
            </div>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4 w-full md:w-auto">
            <div className="flex gap-2" data-testid="diwali-countdown">
              {units.map(([v, l]) => (
                <div key={l} className="glass rounded-lg px-3 py-2 min-w-[56px] text-center">
                  <p className="font-mono text-xl text-gold leading-none">{pad(v)}</p>
                  <p className="text-[10px] text-muted-foreground uppercase tracking-widest mt-1">{l}</p>
                </div>
              ))}
            </div>
            <Link
              to="/collection?collection=Diwali"
              data-testid="diwali-shop-button"
              className="shrink-0 bg-gold text-obsidian font-semibold px-5 py-3 rounded-full hover:bg-gold-light transition-colors whitespace-nowrap"
            >
              Shop Diwali
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
